import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'gold' | 'olive';
  size?: 'lg' | 'md';
  className?: string;
}
export function CtaButton({
  children,
  variant = 'gold',
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const base = 'group inline-flex w-full items-center justify-center gap-2 rounded-xl font-extrabold uppercase tracking-wide transition-all duration-200 focus:outline-none focus-visible:ring-4 focus-visible:ring-[var(--gold)]/40 active:scale-[0.98]';
  const sizes = {
    lg: 'px-6 py-4 text-base sm:text-lg',
    md: 'px-5 py-3 text-sm sm:text-base'
  };
  const variants = {
    gold: 'bg-[var(--gold)] text-black hover:bg-[var(--gold-light)] shadow-[0_0_30px_-8px_rgba(203,163,92,0.7)]',
    olive: 'border-2 border-[var(--olive-light)] bg-transparent text-[var(--cream)] hover:bg-[var(--olive)]/20'
  };
  return <button type="button" className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-51" data-mp="15arf2gcqbdmk">
      <span data-id="element-52" data-mp="35yz42we35ebj">{children}</span>
      <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-53" data-mp="39yrg5j2ou2ln" />
    </button>;
}